import { render, staticRenderFns } from "./style-test-loading.vue?vue&type=template&id=384f9644&scoped=true&"
import script from "./style-test-loading.vue?vue&type=script&lang=js&"
export * from "./style-test-loading.vue?vue&type=script&lang=js&"
import style0 from "./style-test-loading.vue?vue&type=style&index=0&id=384f9644&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f9644",
  null
  
)

export default component.exports